import React from 'react';

import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

function GoBack({route=""}) {

    const [t, i18n] = useTranslation();


    return (
        <div className="page-header goback">
            <li className="icons-list-item">
                <i className="fa fa-angle-left" data-bs-toggle="tooltip" title=""
                   data-bs-original-title="fa fa-angle-left"
                   aria-label="fa fa-angle-left"></i></li>
            <Link className="page-title" to={route}>{t("Retour à la liste")}</Link>
        </div>
    );
}

export default GoBack;